import * as React from 'react';
import { useEffect, useCallback } from 'react';
import { useAppState } from '../core/redux/hooks';
import { useDispatch } from 'react-redux';
import { TIME } from '../language/time';
import moment from 'moment';
import { showTimeoutModalAction } from '../showTimeoutModalAction';


type Props = {};


/**
 * LogoutTimer: a non-rendering component that logs the user out after a certain amount of inactivity.
 */
const LogoutTimer: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const timeoutMin   = useAppState(state => state.config?.timeout || 0);
  const isLoggedIn   = useAppState(state => !!state.auth.currentUser);
  const lastActivity = useAppState(state => state.lastActivity);

  const showModal = useCallback(
    () => {
      dispatch(showTimeoutModalAction(true));
    },
    [dispatch],
  );

  const scheduleModal = useCallback(
    (lastActive) => {
      if (timeoutMin <= 0 || !isLoggedIn) {
        return;
      }

      const remaining = timeoutMin - moment(lastActive).diff(new Date(), 'minutes') - 5;

      if (remaining <= 0) {
        return;
      }

      const handle = window.setTimeout(showModal, remaining * TIME.M);

      return () => window.clearTimeout(handle);
    },
    [timeoutMin, isLoggedIn, showModal],
  );

  useEffect(() => scheduleModal(lastActivity), [lastActivity, scheduleModal]);

  return null;
};

export default LogoutTimer;
